import { QueryFunctionContext, useQuery } from "@tanstack/react-query";
import { configuration } from "src/configuration";
import { queryKeys } from "src/http/hooks/queryKeys";
import { FetchError, MetricDto } from "src/http/types";
import { useAccessToken } from "src/http/use-access-token";

const useGetMetricCollectionRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function getMetricCollection({
    queryKey,
  }: QueryFunctionContext<ReturnType<typeof queryKeys.metrics.getMetricCollection>>): Promise<MetricDto[]> {
    const accessToken = await getAccessToken();
    const [, metricCollectionGuid] = queryKey;

    const response = await fetch(`${configuration.apiRootUrl}/metric-collections/${metricCollectionGuid}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return { getMetricCollection };
};

const useGetMetricCollection = (metricCollectionGuid: string | null) => {
  const { getMetricCollection } = useGetMetricCollectionRequest();

  return useQuery({
    queryKey: queryKeys.metrics.getMetricCollection(metricCollectionGuid),
    queryFn: getMetricCollection,
    enabled: metricCollectionGuid != null,
  });
};

export { useGetMetricCollection };
